import countFirstLetterOccur from './countFirstLetterOccur';

export default items => {
    const countedItemsNamesFirstLetters = countFirstLetterOccur(items);

    const sortedItemsNamesFirstLettersByCount = countedItemsNamesFirstLetters.sort((a, b) => b.count - a.count);

    const itemsSortedByItsNameMostCommonFirstLetter = [];

    sortedItemsNamesFirstLettersByCount.forEach(letter => {
        const itemsStartedWithSpecifiedLetter = items.filter(item => {
            const itemNameFirstLetter = item[0].charAt(0);

            return itemNameFirstLetter === letter.name;
        });

        itemsSortedByItsNameMostCommonFirstLetter.push(...itemsStartedWithSpecifiedLetter);
    });

    return itemsSortedByItsNameMostCommonFirstLetter;
};
